import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import TeamGroupModal from "@/Modals/WebDataManagement/MasterData/TeamGroups/Modal";
import { columns } from "./Columns";
import { useFilters } from "./Filters";
import { teamGroupsMasterDataApi } from "@/apis/apis";

export default function TeamGroupsPage() {
  const filters = useFilters();

  return (
    <MasterDataBaseTable
      label="Team Group"
      apiURL={teamGroupsMasterDataApi}
      columns={columns()}
      filters={filters}
      ModalComponent={TeamGroupModal}
      importData={BASE_IMPORT_DATA.TEAM_GROUPS}
      enableSortData={true}
    />
  );
}
